module.exports = __webpack_public_path__ + "static/media/loading.27690b7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/AntD/assets/img/diagnostic/loading.png
// module id = 5054
// module chunks = 0